<template>
	<div
		class="carsales prose max-w-none bg-gray-50 pb-[140px] antialiased sm:pb-[120px]"
	>
		<PartnerHeaderCarsales />

		<div class="lg:mt-10">
			<CarbarCampaigns />

			<slot />
		</div>

		<PartnerFooter />
	</div>
</template>

<script setup>
import CarbarCampaigns from '@/components/campaigns/CarbarCampaigns.vue'
import PartnerFooter from '@/components/footers/PartnerFooter.vue'
import PartnerHeaderCarsales from '@/components/headers/PartnerHeaderCarsales.vue'

const route = useRoute()
const pageMeta = siteMeta(route.path)
const runtimeConfig = useRuntimeConfig()

if (!route.meta.disableGenericCanonical) {
	useHead(() => ({
		link: [
			{
				rel: 'canonical',
				href: runtimeConfig.public.APP_URL + route.path,
			},
		],
	}))
}

useHead(() => ({
	title: pageMeta?.title,
	meta: [
		{
			name: 'description',
			content: pageMeta?.description,
		},
		{
			name: 'keywords',
			content: pageMeta?.keywords,
		},
	],
	link: [
		{
			rel: 'canonical',
			href: pageMeta?.url,
		},
	],
	htmlAttrs: {
		lang: pageMeta?.locale,
	},
}))

if (import.meta.server) {
	useSeoMeta({
		ogType: pageMeta?.type,
		ogTitle: pageMeta?.title,
		ogUrl: pageMeta?.url,
		ogDescription: pageMeta?.description,
		ogImage: pageMeta?.image,
		ogImageWidth: pageMeta?.imageWidth,
		ogImageHeight: pageMeta?.imageHeight,
		ogLocale: pageMeta?.locale,
		twitterCard: 'summary_large_image',
		twitterSite: '@carbarcomau',
		twitterTitle: pageMeta?.title,
		twitterDescription: pageMeta?.description,
		twitterImage: pageMeta?.image,
	})
}

onBeforeMount(() => {
	useRecaptcha()
})
</script>
